import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import MembershipPage from "./pages/MembershipPage";
import EventsPage from "./pages/EventsPage";
import ContactPage from "./pages/ContactPage";
import PlaceholderPage from "./pages/PlaceholderPage";
import AnlasmaliKurumlarPage from "./pages/AnlasmaliKurumlarPage";
import BoardPage from "./pages/BoardPage";
import TarihcePage from "./pages/TarihcePage";
import TrabzonTarihiPage from "./pages/TrabzonTarihiPage";
import TrabzonKulturuPage from "./pages/TrabzonKulturuPage";
import BaskanMesajiPage from "./pages/BaskanMesajiPage";
import AdminPanel from "./admin/AdminPanel";
import HaberlerPage from "./pages/HaberlerPage";
import GizlilikPage from "./pages/GizlilikPage";
import ProjelerPage from "./pages/ProjelerPage";
import OgrencilerPage from "./pages/OgrencilerPage";
import BursPage from "./pages/BursPage";

const SiteRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<Home />} />

    {/* Kurumsal */}
    <Route path="/kurumsal" element={<AboutPage />} />
    <Route path="/kurumsal/hakkimizda" element={<AboutPage />} />
    <Route path="/kurumsal/baskandan-mesaj" element={<BaskanMesajiPage />} />
    <Route path="/kurumsal/yonetim-kurulu" element={<BoardPage />} />

    {/* Tarihçe */}
    <Route path="/tarihce" element={<TrabzonTarihiPage />} />
    <Route path="/tarihce/tarih" element={<TrabzonTarihiPage />} />
    <Route path="/tarihce/hikaye" element={<TarihcePage />} />
    <Route path="/tarihce/kurucular" element={<PlaceholderPage title="Kurucular ve Emek Verenler" />} />
    <Route path="/tarihce/arsiv" element={<PlaceholderPage title="Fotoğraf Arşivi" />} />
    <Route path="/tarihce/kultur" element={<TrabzonKulturuPage />} />

    {/* Faaliyetler */}
    <Route path="/faaliyetler" element={<EventsPage />} />
    <Route path="/faaliyetler/etkinlikler" element={<EventsPage />} />
    <Route path="/faaliyetler/haberler" element={<HaberlerPage />} />
    <Route path="/faaliyetler/projeler" element={<ProjelerPage />} />

    {/* Topluluk */}
    <Route path="/topluluk" element={<PlaceholderPage title="Topluluk" />} />
    <Route path="/topluluk/genclik" element={<PlaceholderPage title="Gençlik" description="Gençlik komisyonumuz, burs, mentorluk ve kariyer desteği hakkında bilgiler yakında burada." />} />
    <Route path="/topluluk/kadin-aile" element={<PlaceholderPage title="Kadınlar ve Aile" />} />
    <Route path="/topluluk/ogrenciler" element={<OgrencilerPage />} />
    <Route path="/topluluk/meslek-agi" element={<PlaceholderPage title="İş İnsanları / Meslek Ağı" />} />

    {/* Destek */}
    <Route path="/destek" element={<MembershipPage />} />
    <Route path="/destek/uyelik" element={<MembershipPage />} />
    <Route path="/destek/gonulluluk" element={<PlaceholderPage title="Gönüllülük" description="Gönüllü olarak katkı sağlamak isteyenler için form yakında aktif olacak." />} />
    <Route path="/destek/burs" element={<BursPage />} />
    <Route path="/destek/sponsorluk" element={<PlaceholderPage title="Sponsorluk" />} />
    <Route path="/destek/avantajlar" element={<AnlasmaliKurumlarPage />} />

    {/* Medya */}
    <Route path="/medya" element={<PlaceholderPage title="Medya" />} />
    <Route path="/medya/galeri" element={<PlaceholderPage title="Galeri" description="Etkinlik fotoğrafları yakında burada." />} />
    <Route path="/medya/video" element={<PlaceholderPage title="Video" />} />
    <Route path="/medya/basin" element={<PlaceholderPage title="Basında Biz" />} />

    {/* İletişim */}
    <Route path="/iletisim" element={<ContactPage />} />

    {/* Yasal */}
    <Route path="/gizlilik" element={<GizlilikPage />} />

    {/* 404 */}
    <Route path="*" element={<PlaceholderPage title="Sayfa Bulunamadı" description="Aradığınız sayfa mevcut değil." />} />
  </Routes>
);

// SPA route değişimi gtag.js'in kendi otomatik page_view'unu tetiklemez
// (index.html'de send_page_view:false) — her navigasyonda burada manuel gönderiyoruz.
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const AppContent: React.FC = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdmin) return; // Admin panel ziyaretleri Analytics'e gönderilmez.
    window.gtag?.("event", "page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search, isAdmin]);

  if (isAdmin) return <AdminPanel />;

  return (
    <>
      <Navbar />
      <main className="pt-20 lg:pt-[182px]">
        <SiteRoutes />
      </main>
      <Footer />
    </>
  );
};

const App: React.FC = () => (
  <BrowserRouter>
    <AppContent />
  </BrowserRouter>
);

export default App;
